var map = {
	"./ico_albens-bold.png": 4646,
	"./ico_albens.png": 6679,
	"./ico_boiokshelf-p.png": 4813,
	"./ico_boiokshelf.png": 3358,
	"./ico_clover-l.png": 2633,
	"./ico_clover-s.png": 1939,
	"./ico_clover-w.png": 3219,
	"./ico_clover.png": 9422,
	"./ico_datum-bold.png": 4184,
	"./ico_datum.png": 5165,
	"./ico_dia-l.png": 6696,
	"./ico_dia-s.png": 5509,
	"./ico_dia-w.png": 394,
	"./ico_dia.png": 3453,
	"./ico_download-apple.png": 6653,
	"./ico_download-onestore.png": 9875,
	"./ico_download-playstore.png": 2171,
	"./ico_download-stove.png": 6163,
	"./ico_flamen-bold.png": 331,
	"./ico_flamen.png": 3231,
	"./ico_freta-bold.png": 182,
	"./ico_freta.png": 1152,
	"./ico_hakia-bold.png": 4778,
	"./ico_hakia.png": 4377,
	"./ico_heart-l.png": 8594,
	"./ico_heart-s.png": 2795,
	"./ico_heart-w.png": 7500,
	"./ico_heart.png": 5895,
	"./ico_hiems-bold.png": 5506,
	"./ico_hiems.png": 8079,
	"./ico_ink-p.png": 1557,
	"./ico_ink.png": 5667,
	"./ico_jonstina-bold.png": 3602,
	"./ico_jonstina.png": 9245,
	"./ico_paper-p.png": 6752,
	"./ico_paper.png": 1941,
	"./ico_spade-l.png": 391,
	"./ico_spade-s.png": 8956,
	"./ico_spade-w.png": 6654,
	"./ico_spade.png": 8739,
	"./ico_triticum-bold.png": 9982,
	"./ico_triticum.png": 2872,
	"./ico_viridia-bold.png": 431,
	"./ico_viridia.png": 1091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6487;